// tslint:disable
/**
 * JLIVE ADMIN API
 * JLIVE ADMIN API
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @export
 * @interface OrderAddOnShort
 */
export interface OrderAddOnShort {
  /**
   * @type {number}
   * @memberof OrderAddOnShort
   */
  readonly id?: number;
  /**
   * @type {string}
   * @memberof OrderAddOnShort
   */
  readonly title?: string;
  /**
   * @type {number}
   * @memberof OrderAddOnShort
   */
  charged_amount?: number;
  /**
   * @type {string}
   * @memberof OrderAddOnShort
   */
  charged_currency?: OrderAddOnShortChargedCurrencyEnum;
  /**
   * @type {number}
   * @memberof OrderAddOnShort
   */
  charged_tax_rate?: number | null;
  /**
   * @type {boolean}
   * @memberof OrderAddOnShort
   */
  readonly redeemable?: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum OrderAddOnShortChargedCurrencyEnum {
  Usd = 'usd',
  Cad = 'cad',
}
